import { assert, AssertionError, errorToastProps } from '@atlassian/eoc-common';
import { isNotLoaded, mapErrorForResponder } from '../../../common/utils';
import { getResponderNames } from '../../../services/endpoints';
import { messages } from './messages';
const fetchResponders = missingResponders => ({
  setState,
  getState,
  dispatch
}, {
  flagApi,
  intlApi,
  defaultCatch
}) => {
  const {
    responders
  } = getState();
  if (!Object.keys(missingResponders).length) {
    return Promise.resolve();
  }
  const errorItems = mapErrorForResponder(missingResponders);
  setState({
    responders: {
      ...responders,
      ...missingResponders
    }
  });

  //TODO: How to handle if BE returns [], what will be the behaviour?
  return getResponderNames(Object.values(missingResponders).map(({
    id,
    type
  }) => ({
    id,
    type
  }))).then(response => {
    const responseMap = response.values.map(r => ({
      isError: false,
      isLoading: false,
      acknowledged: true,
      ...r
    })).reduce((acc, r) => {
      acc[r.id] = r;
      return acc;
    }, {});
    const responderItemMap = Object.keys(missingResponders).reduce((acc, key) => {
      const itemByEmail = Object.values(responseMap).find(res => res.email === key);
      if (itemByEmail) {
        acc[key] = {
          ...errorItems[key],
          ...itemByEmail
        };
        return acc;
      }
      const itemByAtlassianIdentifier = Object.values(responseMap).find(res => res.atlassianIdentifier === key);
      if (itemByAtlassianIdentifier) {
        acc[key] = {
          ...errorItems[key],
          ...itemByAtlassianIdentifier
        };
        return acc;
      }
      acc[key] = {
        ...errorItems[key],
        ...responseMap[key]
      };
      return acc;
    }, {});
    setState({
      responders: {
        ...getState().responders,
        ...responderItemMap
      }
    });
  }).catch(defaultCatch({
    id: 'fetchResponders',
    httpErrorHandler: () => {
      //Retry will be shown on the toast message
      const dismiss = flagApi.showFlag({
        ...errorToastProps(),
        title: intlApi.formatMessage(messages.fetchError),
        isAutoDismiss: true,
        actions: [{
          content: intlApi.formatMessage(messages.retry),
          onClick: () => {
            dispatch(fetchResponders(missingResponders));
            dismiss();
          }
        }]
      });
      const responders = Object.assign({}, getState().responders, errorItems);
      setState({
        responders
      });
    }
  }));
};

/**
 * It takes missingResponders and updates the store with additional parameters
 * when it is called on the useResponderNames() hook.
 * It sets isLoading to true for every responder item.
 * This function is implemented to batch requests coming from different components.
 */
const batchResponders = requestedResponders => ({
  setState,
  getState,
  dispatch
}, {
  displayName
}) => {
  assert(displayName === 'ResponderNamesWrapper', new AssertionError('useResponderNames', 'Unable to find ResponderNamesWrapper'));
  const missingResponders = requestedResponders.filter(responder => !getState().responders[responder.id]);
  if (!missingResponders.length) {
    return;
  }
  const requestedRespondersMap = requestedResponders.reduce((acc, r) => {
    acc[r.id] = {
      id: r.id,
      type: r.type,
      acknowledged: false,
      isError: false,
      isLoading: true
    };
    return acc;
  }, {});
  const existingResponders = getState().responders;
  const allResponderIds = [...Object.keys(existingResponders), ...Object.keys(requestedRespondersMap)];
  const allResponders = allResponderIds.reduce((acc, key) => {
    acc[key] = {
      ...requestedRespondersMap[key],
      ...existingResponders[key]
    };
    return acc;
  }, {});
  setState({
    responders: allResponders
  });
  const timeoutState = getState().timeout;
  if (timeoutState !== undefined) {
    clearTimeout(timeoutState);
  }

  //It debounces the requested responders(batching)
  const timeout = setTimeout(() => {
    const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value]) => isNotLoaded(value)).map(([key, value]) => [key, {
      ...value,
      acknowledged: true
    }]));
    if (Object.keys(missingResponders).length) {
      dispatch(fetchResponders(missingResponders));
    }
  }, 10);
  setState({
    timeout
  });
};
export const actions = {
  fetchResponders,
  batchResponders
};